import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { toSaveApplicationInput } from 'utils';
import { useHandleApiErrors } from '../useHandleApiErrors';

export const SAVE_APPLICATION_GQL = gql`
  mutation saveApplication($input: SaveApplicationInput!) {
    saveApplication(input: $input) {
      status
    }
  }
`;

export function useSaveApplication({ storeState, onSuccess, onError }) {
  const { applicationId } = storeState;

  const { handleError } = useHandleApiErrors('apollo', onError);
  const [saveApplication, { loading }] = useMutation(SAVE_APPLICATION_GQL, {
    ...(onSuccess
      ? {
          onCompleted: data => {
            onSuccess(data.saveApplication);
          },
        }
      : {}),
    onError: err => {
      handleError(err);
    },
  });

  const save = useCallback(
    formData => {
      if (formData) {
        const input = { applicationId, ...toSaveApplicationInput(formData, storeState) };
        saveApplication({ variables: { input } });
      }
    },
    [applicationId, storeState, saveApplication],
  );

  return {
    save,
    loading,
  };
}
